var map = {
	"./BASSLINE  smooth_1.wav": 55,
	"./HOW GREAT - vocal loop_1.wav": 56,
	"./WMIS - KIT_1.wav": 57,
	"./WMIS - loop_1.wav": 58,
	"./drum loop_1.wav": 59,
	"./felipe_1.wav": 60,
	"./gunshot - 808 - L_1.wav": 61,
	"./gunshot - 808 - R_1.wav": 62,
	"./piano intro_1.wav": 63,
	"./vocal jodida_1.wav": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;